var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 86,
    viewBox: "0 0 79 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9175 6.923C58.9619 4.01297 66.5172 14.9644 77.4827 12.3722C77.8912 10.2604 78.3009 8.14728 78.7106 6.03186C67.8262 8.3062 60.2686 -2.63818 49.1394 0.606166C48.7333 2.70981 48.3248 4.81582 47.9175 6.923Z",
    fill: "#EE7C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7134 13.1386C57.6778 10.5488 65.233 21.5002 76.2786 18.5878C76.6871 16.4807 77.0956 14.3711 77.5041 12.2592C66.5409 14.8467 58.9856 3.89409 47.9388 6.81C47.5315 8.91836 47.123 11.0279 46.7134 13.1386Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4961 19.4225C56.3816 17.1482 63.938 28.0926 75.0672 24.8482C75.4745 22.7446 75.8819 20.6385 76.2892 18.5314C65.2447 21.4414 57.6895 10.4899 46.7239 13.0821C46.3154 15.194 45.9069 17.3071 45.4961 19.4225Z",
    fill: "#008D3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6185 9.87891L62.4996 11.5964L62.4183 12.0191L62.3359 12.4417L62.3477 12.0143L62.3595 11.5882L62.6185 9.87891Z",
    fill: "#3498C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1918 10.0002L62.6856 11.6566L62.5113 12.0486L62.3359 12.4417L62.4454 12.025L62.5537 11.6083L63.1918 10.0002Z",
    fill: "#3498C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7074 10.2861L62.848 11.7706L62.5926 12.1061L62.3359 12.4416L62.5361 12.0625L62.735 11.6835L63.7074 10.2861Z",
    fill: "#3498C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.13 10.7195L62.9752 11.9296L62.6561 12.1851L62.3359 12.4417L62.6114 12.1274L62.888 11.8107L64.13 10.7195Z",
    fill: "#3498C1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4302 11.2703L63.0587 12.1237L62.6973 12.2827L62.3359 12.4416L62.6703 12.212L63.0034 11.9825L64.4302 11.2703Z",
    fill: "#3498C1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5879 11.9014L63.0929 12.3405L62.715 12.3911L62.3359 12.4417L62.7044 12.3134L63.0729 12.1851L64.5879 11.9014Z",
    fill: "#3498C1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5914 12.5689L63.0752 12.563L62.7068 12.5029L62.3359 12.4417L62.715 12.4229L63.0929 12.4041L64.5914 12.5689Z",
    fill: "#3498C1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4419 13.228L63.0081 12.7783L62.6714 12.61L62.3359 12.4417L62.6985 12.5346L63.0623 12.6265L64.4419 13.228Z",
    fill: "#3498C1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1488 13.8331L62.8951 12.9702L62.6161 12.7065L62.3359 12.4417L62.6585 12.6382L62.9799 12.836L64.1488 13.8331Z",
    fill: "#3498C1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7321 14.344L62.7432 13.1268L62.5396 12.7842L62.3359 12.4417L62.5961 12.7301L62.8551 13.0185L63.7321 14.344Z",
    fill: "#3498C1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.22 14.7254L62.5643 13.2351L62.4501 12.8395L62.3359 12.4417L62.5161 12.8019L62.695 13.1633L63.22 14.7254Z",
    fill: "#3498C1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6479 14.9502L62.3689 13.2916L62.3524 12.8666L62.3359 12.4417L62.423 12.849L62.509 13.2563L62.6479 14.9502Z",
    fill: "#3498C1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0542 15.0044L62.1719 13.288L62.2543 12.8654L62.3356 12.4417L62.3238 12.869L62.312 13.2963L62.0542 15.0044Z",
    fill: "#3498C1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.481 14.8843L61.9872 13.2268L62.1614 12.8348L62.3356 12.4417L62.2273 12.8595L62.1178 13.2775L61.481 14.8843Z",
    fill: "#3498C1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9644 14.5983L61.8249 13.1138L62.0792 12.7771L62.3358 12.4417L62.1369 12.8219L61.9379 13.2009L60.9644 14.5983Z",
    fill: "#3498C1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5415 14.1639L61.6963 12.9537L62.0165 12.6971L62.3355 12.4417L62.0601 12.7571L61.7835 13.0726L60.5415 14.1639Z",
    fill: "#3498C1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2427 13.613L61.6141 12.7595L61.9755 12.6006L62.3357 12.4417L62.0014 12.6724L61.6683 12.9019L60.2427 13.613Z",
    fill: "#3498C1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0835 12.9832L61.5785 12.5429L61.9576 12.4934L62.3355 12.4417L61.967 12.57L61.5985 12.6994L60.0835 12.9832Z",
    fill: "#3498C1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0815 12.3145L61.5966 12.3192L61.9662 12.3804L62.3359 12.4416L61.958 12.4604L61.5789 12.4793L60.0815 12.3145Z",
    fill: "#3498C1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2295 11.6565L61.6633 12.1062L62 12.2733L62.3355 12.4417L61.9729 12.3499L61.6103 12.2569L60.2295 11.6565Z",
    fill: "#3498C1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5239 11.0503L61.7765 11.9132L62.0566 12.1781L62.3356 12.4417L62.0143 12.2451L61.6917 12.0474L60.5239 11.0503Z",
    fill: "#3498C1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9409 10.5393L61.9286 11.7565L62.1322 12.1003L62.3359 12.4417L62.0769 12.1532L61.8167 11.8648L60.9409 10.5393Z",
    fill: "#3498C1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4517 10.1602L62.1085 11.6481L62.2227 12.0448L62.3357 12.4416L62.1556 12.0813L61.9779 11.7211L61.4517 10.1602Z",
    fill: "#3498C1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0239 9.9353L62.3029 11.594L62.3194 12.0178L62.3359 12.4416L62.2488 12.0342L62.1628 11.6269L62.0239 9.9353Z",
    fill: "#3498C1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6279 9.78948C63.9169 9.86246 64.8316 11.1091 64.6704 12.5735C64.5091 14.038 63.3342 15.1669 62.0452 15.0951C60.755 15.0221 59.8415 13.7766 60.0016 12.311C60.1629 10.8466 61.3377 9.71649 62.6279 9.78948ZM62.6067 9.98608C61.4119 9.91897 60.3242 10.9631 60.1746 12.3204C60.0251 13.6778 60.8727 14.8326 62.0676 14.8997C63.2612 14.9668 64.3513 13.9203 64.4997 12.5641C64.648 11.2068 63.8004 10.0532 62.6067 9.98608Z",
    fill: "#3498C1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8867 9.92472C62.9491 9.92825 62.9927 9.98947 62.9856 10.0601C62.9774 10.1307 62.9209 10.1849 62.8596 10.1813C62.7972 10.1778 62.7525 10.1178 62.7607 10.0472C62.7666 9.97652 62.8231 9.92119 62.8867 9.92472Z",
    fill: "#3498C1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4354 10.1225C63.4943 10.1448 63.5226 10.2166 63.4978 10.2837C63.4743 10.3508 63.4084 10.3885 63.3495 10.3662C63.2918 10.345 63.2636 10.272 63.2871 10.2061C63.3107 10.1378 63.3778 10.1013 63.4354 10.1225Z",
    fill: "#3498C1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9101 10.4794C63.9596 10.5182 63.9702 10.5959 63.9313 10.6571C63.8925 10.716 63.8219 10.7336 63.7724 10.6948C63.7218 10.6571 63.7124 10.5771 63.75 10.5182C63.7889 10.4582 63.8595 10.4417 63.9101 10.4794Z",
    fill: "#3498C1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2769 10.9701C64.3157 11.0219 64.3063 11.1032 64.2569 11.1502C64.2074 11.1985 64.1356 11.195 64.0968 11.1408C64.0579 11.089 64.0673 11.0078 64.1168 10.9607C64.1662 10.9136 64.238 10.9172 64.2769 10.9701Z",
    fill: "#3498C1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5115 11.5599C64.5362 11.6223 64.5091 11.7011 64.4515 11.7329C64.3938 11.7647 64.3267 11.74 64.302 11.6764C64.2772 11.614 64.3055 11.5363 64.362 11.5034C64.422 11.4716 64.488 11.4975 64.5115 11.5599Z",
    fill: "#3498C1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5987 12.2109C64.6069 12.2791 64.5645 12.3474 64.5021 12.3616C64.4398 12.3769 64.3833 12.3333 64.3738 12.2638C64.3644 12.1944 64.408 12.1261 64.4704 12.1108C64.5328 12.0967 64.5893 12.1402 64.5987 12.2109Z",
    fill: "#3498C1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5315 12.8761C64.5232 12.9479 64.4667 13.0009 64.4043 12.9973C64.3419 12.9938 64.2984 12.9349 64.3054 12.8631C64.3137 12.7925 64.3702 12.7383 64.4314 12.7419C64.495 12.7454 64.5385 12.8054 64.5315 12.8761Z",
    fill: "#3498C1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3139 13.5129C64.2892 13.5812 64.2244 13.6177 64.1656 13.5953C64.1067 13.5742 64.0796 13.5012 64.1032 13.4341C64.1267 13.3681 64.1927 13.3317 64.2515 13.3517C64.3104 13.374 64.3375 13.4447 64.3139 13.5129Z",
    fill: "#3498C1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9616 14.0767C63.9251 14.1356 63.8533 14.1532 63.8027 14.1156C63.7521 14.0767 63.7427 13.9967 63.7803 13.9378C63.818 13.8778 63.8898 13.8613 63.9392 13.9001C63.9899 13.9366 63.9993 14.0155 63.9616 14.0767Z",
    fill: "#3498C1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4989 14.5289C63.4494 14.5771 63.3788 14.5736 63.3399 14.5194C63.3011 14.4665 63.3105 14.3864 63.36 14.3381C63.4106 14.2911 63.4812 14.2946 63.5189 14.3476C63.5577 14.3994 63.5483 14.4806 63.4989 14.5289Z",
    fill: "#3498C1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9578 14.8384C62.9001 14.8702 62.833 14.8467 62.8095 14.7819C62.7847 14.7195 62.8118 14.6418 62.8695 14.61C62.9272 14.5783 62.9931 14.603 63.0178 14.6654C63.0425 14.7278 63.0155 14.8066 62.9578 14.8384Z",
    fill: "#3498C1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3727 14.9856C62.3104 14.9997 62.2538 14.9562 62.2444 14.8879C62.235 14.8185 62.2797 14.7502 62.3421 14.7349C62.4045 14.7184 62.4622 14.7631 62.4704 14.8326C62.4787 14.9032 62.4351 14.9703 62.3727 14.9856Z",
    fill: "#3498C1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7862 14.9596C61.725 14.9561 61.6802 14.8949 61.6885 14.8243C61.6967 14.7524 61.7532 14.6983 61.8144 14.7018C61.8768 14.7054 61.9216 14.7654 61.9133 14.8372C61.9051 14.9078 61.8486 14.9632 61.7862 14.9596Z",
    fill: "#3498C1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2367 14.7609C61.179 14.7397 61.1508 14.6667 61.1743 14.5996C61.1979 14.5313 61.265 14.4948 61.3227 14.516C61.3803 14.5372 61.4086 14.6102 61.385 14.6773C61.3615 14.7456 61.2944 14.7821 61.2367 14.7609Z",
    fill: "#3498C1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7622 14.404C60.7115 14.3651 60.7021 14.2863 60.7398 14.2274C60.7775 14.1674 60.8481 14.1497 60.8987 14.1897C60.9493 14.2274 60.9587 14.3063 60.9211 14.3651C60.8834 14.4252 60.8128 14.4428 60.7622 14.404Z",
    fill: "#3498C1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3961 13.913C60.3572 13.8612 60.3667 13.78 60.4161 13.7329C60.4644 13.6858 60.5374 13.6894 60.575 13.7423C60.6139 13.7941 60.6044 13.8754 60.555 13.9225C60.5056 13.9707 60.4338 13.9672 60.3961 13.913Z",
    fill: "#3498C1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1609 13.3234C60.1361 13.261 60.1644 13.1833 60.2209 13.1503C60.2797 13.1186 60.3457 13.1444 60.3704 13.2068C60.3951 13.2692 60.368 13.3469 60.3104 13.3799C60.2515 13.4117 60.1856 13.3858 60.1609 13.3234Z",
    fill: "#3498C1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0745 12.6747C60.0651 12.6053 60.1087 12.537 60.171 12.5217C60.2334 12.5052 60.29 12.5511 60.2994 12.6194C60.3088 12.6888 60.264 12.7571 60.2028 12.7724C60.1404 12.7865 60.0828 12.743 60.0745 12.6747Z",
    fill: "#3498C1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1404 12.0071C60.1486 11.9353 60.2052 11.8824 60.2675 11.8859C60.3299 11.8894 60.3747 11.9483 60.3664 12.0201C60.3582 12.0907 60.3017 12.1449 60.2393 12.1414C60.1769 12.1378 60.1333 12.0778 60.1404 12.0071Z",
    fill: "#3498C1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3584 11.3716C60.382 11.3033 60.4479 11.2668 60.5056 11.288C60.5644 11.3092 60.5915 11.3822 60.568 11.4493C60.5444 11.5175 60.4785 11.5529 60.4196 11.5317C60.3631 11.5105 60.3349 11.4387 60.3584 11.3716Z",
    fill: "#3498C1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7114 10.8067C60.749 10.7478 60.8197 10.7301 60.8703 10.769C60.9209 10.8067 60.9303 10.8855 60.8926 10.9467C60.8538 11.0056 60.7832 11.0221 60.7337 10.9844C60.6819 10.9468 60.6725 10.8655 60.7114 10.8067Z",
    fill: "#3498C1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1729 10.3557C61.2224 10.3086 61.2942 10.3122 61.3318 10.3651C61.3707 10.4181 61.3625 10.4993 61.3118 10.5453C61.2624 10.5935 61.1906 10.59 61.1529 10.5358C61.1152 10.484 61.1235 10.4028 61.1729 10.3557Z",
    fill: "#3498C1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7159 10.0449C61.7735 10.0119 61.8395 10.0378 61.8642 10.1002C61.8889 10.1626 61.8607 10.2415 61.8041 10.2733C61.7465 10.3051 61.6805 10.2815 61.6546 10.2168C61.6311 10.1555 61.657 10.0779 61.7159 10.0449Z",
    fill: "#3498C1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2995 9.89767C62.3618 9.88355 62.4183 9.9271 62.4278 9.99773C62.436 10.0672 62.3925 10.1343 62.3301 10.1496C62.2688 10.1637 62.2112 10.1202 62.2029 10.0507C62.1935 9.98125 62.2382 9.91298 62.2995 9.89767Z",
    fill: "#3498C1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3726 12.118C62.5303 12.1274 62.641 12.2793 62.6221 12.4571C62.6021 12.636 62.4585 12.7737 62.3019 12.7643C62.1454 12.7549 62.0335 12.6042 62.0524 12.4253C62.0712 12.2475 62.2148 12.1098 62.3726 12.118Z",
    fill: "#3498C1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M40.957 43.369L49.1527 0.592041",
    stroke: "#0047AB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M18.5137 78.4036L18.4784 78.3141L4.38505 44.3909L0 33.3512L9.08441 30.1362C9.20566 33.4183 9.51527 38.8628 10.2946 44.0142L10.2852 43.8753C11.2093 51.261 12.7514 59.6815 15.267 68.4622C15.267 68.4622 15.3483 68.7447 15.4683 69.1532C15.5849 69.5617 15.7462 70.0902 15.8992 70.6059C15.8992 70.6059 15.8992 70.6106 15.8992 70.6153C16.1099 71.3145 16.33 72.0232 16.5584 72.7272C17.16 74.6095 17.8098 76.5024 18.5137 78.4036Z",
    fill: "#2A72DA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4035 17.7921C31.4941 17.7921 35.6209 13.8092 35.6209 8.89607C35.6209 3.9829 31.4941 0 26.4035 0C21.3128 0 17.186 3.9829 17.186 8.89607C17.186 13.8092 21.3128 17.7921 26.4035 17.7921Z",
    fill: "#0047AB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7289 71.3722L45.1242 74.188C43.4962 71.0897 40.0352 69.0355 36.1199 69.3451C31.537 69.7123 27.883 73.3946 27.6947 77.8291C27.6229 79.4842 28.0172 81.044 28.7706 82.399L28.3892 82.5873L25.3933 84.0894H25.3886L21.5862 86L18.5149 78.4036C17.8109 76.5024 17.1611 74.6095 16.5596 72.7271C16.3312 72.0232 16.1111 71.3145 15.9004 70.6152C15.9004 70.6105 15.9004 70.6058 15.9004 70.6058C15.7485 70.0902 15.586 69.5605 15.4695 69.1532C15.3483 68.7447 15.2682 68.4622 15.2682 68.4622C12.7525 59.6826 11.2104 51.261 10.2863 43.8753L10.2957 44.0142C9.51525 38.8616 9.20565 33.4182 9.08558 30.1362C9.01377 28.2527 9.00435 27.0826 9.00435 27.0826C8.96432 25.6123 8.9502 24.2891 8.9502 23.1143C8.9502 22.4056 8.95019 21.751 8.96314 21.1589C8.99846 18.8092 9.0844 17.4143 9.09734 17.2224C9.09734 17.2047 9.09734 17.1953 9.09734 17.1953L14.0074 17.864L16.4866 18.276C16.4689 18.4961 16.4595 18.7151 16.4595 18.9352C16.4595 23.85 20.5844 27.8313 25.6746 27.8313C29.9208 27.8313 33.49 25.0649 34.5624 21.2978L37.2076 21.7416L41.2477 22.4503V22.468C41.2383 22.6022 41.1312 24.5893 41.1441 27.7771C41.1441 27.7771 41.3819 36.7721 41.7633 40.2436C42.2389 45.1631 43.0453 50.6159 44.4179 55.9474C44.4226 55.9651 44.4273 55.9745 44.4309 55.9921C44.9465 58.0864 45.0183 58.1535 45.023 58.1535C46.3921 62.8976 48.2438 67.4627 50.7289 71.3722Z",
    fill: "#6495ED"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5864 86C20.4658 83.4714 19.4428 80.9334 18.5151 78.4036L21.5864 86Z",
    fill: "#0047AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/India.4019ddd8d222d1fc2fc115c5638d0420.svg";
export { ForwardRef as ReactComponent };